import { render, staticRenderFns } from "./pagination2.vue?vue&type=template&id=0f8dfbcf&scoped=true"
import script from "./pagination2.vue?vue&type=script&lang=js"
export * from "./pagination2.vue?vue&type=script&lang=js"
import style0 from "./pagination2.vue?vue&type=style&index=0&id=0f8dfbcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8dfbcf",
  null
  
)

export default component.exports